import { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, BrowserRouterProps, Routes } from 'react-router-dom';
import { UIProvider } from '../contexts/UIProvider.tsx';
import { IThemeContext } from '../interfaces/types';
import { LocationProvider } from '../contexts/LocationProvider.tsx';
import { ProfileProvider } from '../contexts/ProfileProvider.tsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export function RootTemplate({
  children,
  browserRouterProps = {},
  themeResolver,
}: {
  browserRouterProps?: BrowserRouterProps;
  themeResolver: () => Promise<IThemeContext | null>;
} & PropsWithChildren) {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ProfileProvider>
          <BrowserRouter {...browserRouterProps}>
            <UIProvider themeResolver={themeResolver}>
              <LocationProvider>
                <Routes>{children}</Routes>
              </LocationProvider>
            </UIProvider>
          </BrowserRouter>
        </ProfileProvider>
      </QueryClientProvider>
    </>
  );
}
